import React from 'react'

function Unauthorized() {
  return (
    <div>
      <div className='unauthorized-main-content'>  Unauthorized Access ! </div>
      </div>
  )
}

export default Unauthorized